import { jsx as _jsx } from "react/jsx-runtime";
import "./TransparentBackground.css";
export function TransparentBackground() {
    return _jsx("div", { className: "transparentBackground" });
}
export default TransparentBackground;
